<template>
  <v-container
    class="ma-0 pt-0 pb-0 action-container"
  >
    <v-row
    no-gutters
    :class="getSelectedShipment ? 'visible' : 'not-visible'"
    >
      <v-col
        cols="12"
        class="pt-0"
      >
        <v-row
          align="center"
          justify="center"
          class="pa-0 mb-1"
        >
          <v-col
            cols="4"
            class="text-center pt-0"
          >
            <div
            :class="{'active-action': selectedView === 'overview'}"
            class="d-flex flex-column align-center"
            @click="handleActionButton('overview')"
            >
              <v-btn class="no-background-hover" :ripple="false" text height="30">
                <align-center-icon
                class="action-icon"
                :class="{'active': selectedView === 'overview', 'md': $vuetify.breakpoint.lgAndDown }"
                />
              </v-btn>
              <p
              class="mb-0 font-weight-medium action-text"
              :class="{'active': selectedView === 'overview'}"
              >{{$t('overview')}}</p>
            </div>
          </v-col>
          <v-col
            cols="4"
            class="text-center pt-0"
          >
          <div
            :class="{'active-action': selectedView === 'map'}"
            class="d-flex flex-column align-center action-button"
            @click="handleActionButton('map')"
            >
              <v-btn class="no-background-hover" :ripple="false" text height="30">
                <map-icon
                class="action-icon "
                :class="{'active': selectedView === 'map', 'md': $vuetify.breakpoint.lgAndDown }"
                />
              </v-btn>
              <p
              class="mb-0 font-weight-medium action-text"
              :class="{'active': selectedView === 'map'}"
              >{{$t('locations.map')}}</p>
            </div>
          </v-col>
          <v-col
            cols="4"
            class="text-center pt-0"
          >
          <div
            :class="{'active-action': selectedView === 'quote'}"
            class="d-flex flex-column align-center"
            @click="handleActionButton('quote')"
            >
              <v-btn class="no-background-hover" :ripple="false" text height="30">
                <dollar-sign-icon
                class="action-icon"
                :class="{'active': selectedView === 'quote', 'md': $vuetify.breakpoint.lgAndDown }"
                />
              </v-btn>
              <p
              class="mb-0 font-weight-medium action-text"
              :class="{'active': selectedView === 'quote'}"
              >{{$t('quotes.quote')}}</p>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
      >
        <v-row
          align="center"
          justify="center"
          class="pa-0 mb-1"
        >
           <v-col
            cols="4"
            class="text-center pt-0"
          >
            <div
            :class="{'active-action': selectedView === 'drops'}"
            class="d-flex flex-column align-center"
            @click="handleActionButton('drops')"
            >
              <v-btn class="no-background-hover" :ripple="false" text height="30">
                <v-icon
                class="action-icon"
                :class="{'active': selectedView === 'drops', 'md': $vuetify.breakpoint.lgAndDown }"
                >
                fas fa-pallet
                </v-icon>
              </v-btn>
              <p
              class="mb-0 font-weight-medium action-text"
              :class="{'active': selectedView === 'drops'}"
              >{{$t('drops.drops')}}</p>
            </div>
          </v-col>
          <v-col
            cols="4"
            class="text-center pt-0"
          >
          <div
            :class="{'active-action': selectedView === 'schedule'}"
            class="d-flex flex-column align-center"
            @click="handleActionButton('schedule')"
            >
              <v-btn class="no-background-hover" :ripple="false" text height="30">
                <v-icon
                class="action-icon"
                :class="{'active': selectedView === 'schedule', 'md': $vuetify.breakpoint.lgAndDown }"
                >
                fas fa-clipboard-list
                </v-icon>
              </v-btn>
              <p
              class="mb-0 font-weight-medium action-text"
              :class="{'active': selectedView === 'schedule'}"
              >{{$t('shipments.schedule')}}</p>
            </div>
          </v-col>
          <v-col
            cols="4"
            class="text-center pt-0"
          >
          <div
            class="d-flex flex-column align-center"
            >
              <ShipmentsGroupByDayExportSchedule />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ShipmentsGroupByDayExportSchedule from '@/components/shipmentsByDay/context/ShipmentsGroupByDayExportSchedule'

  export default {
    name: 'ShipmentsGroupByDayActions',
    components: {
      ShipmentsGroupByDayExportSchedule
    },
    data () {
      return {
        selectedView: 'overview'
      }
    },
    mounted () {
      if (this.$route.params.shipmentView != null) {
        this.setSelectedShipment({ shipmentID: this.$route.params.shipmentID })
        this.setSelectedView({ view: this.$route.params.shipmentView })
      }
    },
    methods: {
      ...mapActions({
        setSelectedView: 'shipmentsGroupByDay/setSelectedView',
        setShipmentsGroupByDayLastUrl: 'shipmentsGroupByDay/setShipmentsGroupByDayLastUrl',
        setSelectedShipment: 'shipmentsContext/setSelectedShipment'
      }),
      handleActionButton (view) {
        if (this.selectedView === 'overview') {
          this.setShipmentsGroupByDayLastUrl({ url: this.$route.fullPath })
        }
        if (view === 'overview') {
          this.$router.push({ path: this.getLastUrl != null ? this.getLastUrl : '/shipments-by-day' })
        }
        if (this.getSelectedShipment != null) {
          this.setSelectedView({ view })
        }
      },
    },
    computed: {
      ...mapGetters({
        getSelectedView: 'shipmentsGroupByDay/getSelectedView',
        getSelectedShipment: 'shipmentsContext/getSelectedShipment',
        getLastUrl: 'shipmentsGroupByDay/getLastUrl'
      }),
    },
    watch: {
      getSelectedView: {
        deep: true,
        immediate: true,
        handler (val) {
          this.selectedView = val
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .action-container {
    border-bottom: 2px solid #EBEAEB;
    .action-icon {
      color: #777777 !important;
      font-size: 30px;
      width: 30px;
      height: 30px;
      &.active {
        color: #EE4747 !important;
      }
      &.md {
        font-size: 20px;
        width: 20px;
        height: 20px;
      }
    }
    .action-button {
      cursor: pointer;
    }
    .active-action {
      color: #EE4747 !important;
      background-color: #EBEAEB;
      border-radius: 5px;
    }
    .action-text {
      font-size: 13px;
      color: #777777;
      &.active {
        color: #EE4747 !important;
      }
    }
    .visible {
      visibility: visible;
    }
    .not-visible {
      visibility: hidden;
    }
  }
</style>
